<template>
    <DefaultLayout>
        <v-container fluid style="overflow-y: auto; height: 100%;" class="pt-0">
          <div class="d-flex flex-column align-center overflow-auto mt-4 mt-sm-16">
            <Ligipaasetavus/>
          </div>
        </v-container>
    </DefaultLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Ligipaasetavus from "@/components/ligipaasetavus/Ligipaasetavus.vue";
import DefaultLayout from "@/components/uldine/DefaultLayout.vue";

export default defineComponent({
    name: 'LigipaasetavusLogiSisseLeht',
    components: {
        Ligipaasetavus,
        DefaultLayout
    },
});
</script>

<style scoped>

</style>